import { CONNECTORS_IDS } from "./sources"

export const DEFAULT_REVENUE_SOURCE = CONNECTORS_IDS.GOOGLE_ANALYTICS_4
